const transitionProperties = {
  control: '150ms ease-out',
};

export const transitions = {
  control: `
    background ${transitionProperties.control},
    box-shadow ${transitionProperties.control},
    color ${transitionProperties.control},
    fill ${transitionProperties.control},
    opacity ${transitionProperties.control},
    outline ${transitionProperties.control},
    stroke ${transitionProperties.control},
    transform ${transitionProperties.control}
  `,

  /** The halo alone, for elements that draw one and have nothing else to animate. */
  focusRing: `box-shadow ${transitionProperties.control}`,

  /** A fade alone, for elements that only ever appear and disappear. */
  opacity: `opacity ${transitionProperties.control}`,
};

/** The timing the transitions above share, for a property they don't cover. */
export const transitionTiming = transitionProperties.control;
